<div class="deployment-step-content full-height-flex">
  <div class="remaining-space-flex-content-wrapper">
    <div class="remaining-space-flex-content">
      <div class='step-content full-height-flex'>
        <div class="remaining-space-flex-content-wrapper">
          <div class="remaining-space-flex-content">
            @if (shouldDisplayValidating$ | async) {
              <adm4-validating
                class='full-height'
                [validatingText]='getValidatingText(selectedInventorySchemaType$ | async)'
                [validationDoneText]='getValidationDoneText(selectedInventorySchemaType$ | async)'
                [status]='planningStatus$ | async'>
                @if (noDeploymentNeeded$ | async) {
                  <span class='success'>
                    {{hostsCount$ | async}} hosts are up to date, no deployment is needed. You can <a (click)='triggerForceRedeployment(deploymentId)'>force redeployment</a>.
                  </span>
                }
              </adm4-validating>
            } @else {
              <adm4-deployment-preview-container class='full-height'
                [planningResults]='planningOutput$ | async'
                [redeploymentForced]='redeploymentForced$ | async'
                [boxShadowClass]='boxShadowClass'
                [patterns]='patterns$ | async'
                [selectedInventorySchemaType]='selectedInventorySchemaType$ | async'
              ></adm4-deployment-preview-container>
            }
          </div>
        </div>
        <div class="step-content-action-bar">
          @if (canRepeatPlanning$ | async) {
            <button
              class='step-content-action-button'
              (click)="onRepeatPlanning()">
              <span class="material-icons">replay</span>
              <span>{{getRepeatPlanningButtonText(selectedInventorySchemaType$ | async)}}</span>
            </button>
          }
          @if (canShowForceRedeploymentButton$ | async) {
            <button
              class='step-content-action-button'
              (click)='triggerForceRedeployment(deploymentId)'>
              <span class="material-icons">settings_backup_restore</span>
              <span>Force redeployment</span>
            </button>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="step-action-bar">
    @if (isPlanningInProgress$ | async) {
      <button
        class='previous-step-button'
        (click)='triggerAbortPlanning()'>Abort planning
      </button>
    } @else {
      @if (canGoBack$ | async) {
        <button
          matStepperPrevious
          class='previous-step-button'>
          Validate
        </button>
      }
      @if (canDeploy$ | async) {
        <div
          class='button-wrapper'
          [ngbTooltip]='disabledNextStepToolTip' [disableTooltip]='!(isPlanningEntirelyFailed$ | async)' placement='top'>
          <button matStepperNext
            class='next-step-button next-step-icon icon-play'
            [disabled]='isPlanningEntirelyFailed$ | async'
            (click)='deploy.emit(deploymentId)'>
            Deploy now
          </button>
        </div>
      }
    }
    @if (canShowCloseButton$ | async) {
      <button
        class='admn4-button-ellipse-blue close-button'
        (click)='closeWizard.emit()'>Close wizard
      </button>
    }
    <ng-template #disabledNextStepToolTip>
      <span>
        There is nothing to be deployed. Please solve the failures and <a (click)='onRepeatPlanning()'>{{getDisabledNextStepToolTipLinkText(selectedInventorySchemaType$ | async)}}</a>.
      </span>
    </ng-template>
  </div>
</div>
